import React from "react";
import axios from "axios";
import { GoogleLogin } from "@react-oauth/google";
import { setCookie } from "./helpers";
import "./Signin.css";

class Signin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      errorMessage: "",
    };
  }

  onGoogleLogin = async (credentialResponse) => {
    this.setState({ errorMessage: "" });

    try {
      const loginResponse = await axios.post("/api/signin", {
        googleResponse: credentialResponse,
      });
      this.processSuccessfulSigninActions(loginResponse);
    } catch (e) {
      if (e.response.status === 404) {
        this.setState({
          errorMessage:
            "Facebook user is not signed up. Please create an account first.",
        });
      } else {
        this.setState({
          errorMessage:
            "An error has occurred. Please try your request again later.",
        });
      }
    }
  };

  onGoogleLoginError = () => {
    this.setState({ errorMessage: "Google login failed. Please try again." });
  };

  processSuccessfulSigninActions(response) {
    const token = response.headers.authorization;

    // matches jwt.expiration_time on the service; a longer lived cookie only
    // buys a session that looks valid and is not
    setCookie("ez_t", token, 1);

    // a warehouse worker sent here from /3pl belongs back on /3pl, not on the
    // office order grid
    const next = new URLSearchParams(window.location.search).get("next");

    const isInternal = next && next.startsWith("/") && !next.startsWith("//");

    window.location = isInternal ? next : "/supplychain";
  }

  render() {
    return (
      <div className="signin-container">
        <div className="signin-title">Welcome to EZ ICE Admin!</div>
        <GoogleLogin
          onSuccess={this.onGoogleLogin}
          onError={this.onGoogleLoginError}
        />
      </div>
    );
  }
}

export default Signin;
